"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../utils");
var Date = function (_a) {
    var date = _a.date;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(antd_1.Typography.Text, null,
            (0, utils_1.formatDate)(date),
            " ",
            (0, utils_1.formatTime)(date))));
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 120px !important;\n"], ["\n  width: 120px !important;\n"])));
exports.default = Date;
var templateObject_1;
//# sourceMappingURL=date.js.map